import { Suspense, useState } from "react";
import { twMerge } from "tailwind-merge";

import { Card } from "@/components/Card";
import { Subtitle } from "@/components/Subtitle";
import { TextLoading } from "@/components/TextLoading";

import { EditingProfileCard } from "./EditingProfileCard";
import { StaticProfileCard } from "./StaticProfileCard";

export function ProfileCard(props: { accountId: string; className?: string }) {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <Suspense
      fallback={
        <Card className={twMerge("flex flex-row flex-wrap gap-8 p-4", props.className)}>
          <div className="relative aspect-[88_/_80] h-auto w-88 max-w-full shrink-0">
            <div className="absolute z-10 aspect-square h-full overflow-hidden rounded-sm bg-white shadow-lg">
              <div className="size-full bg-black/10 animate-pulse animate-duration-2000" />
            </div>
            <div className="absolute left-0 z-0 aspect-square h-full translate-x-16/80 scale-80 overflow-hidden rounded-sm bg-white shadow-lg">
              <div className="size-full bg-black/10 animate-pulse animate-duration-2000" />
            </div>
          </div>
          <div className="flex grow basis-1/3 flex-col gap-2">
            <Subtitle>
              <TextLoading />
            </Subtitle>

            <div className="mt-8 flex flex-col gap-2">
              <p>
                <TextLoading />
              </p>
              <p>
                <TextLoading />
              </p>
            </div>
          </div>
        </Card>
      }
    >
      {isEditing ? (
        <EditingProfileCard onStopEditing={() => setIsEditing(false)} {...props} />
      ) : (
        <StaticProfileCard onEdit={() => setIsEditing(true)} {...props} />
      )}
    </Suspense>
  );
}
